var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneUzb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_203_8106",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_203_8106)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_203_8106",
    transform: "scale(0.004 0.008)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_203_8106",
    width: 250,
    height: 125,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAB9CAIAAAAEO+kKAAAE7UlEQVR4nO3dzU8cZQDH8eFts6UUyrbAglKzQApNDbFNIK2JGPWgFw2JjSZUTxw8NSZ4sNhzLV6Qgxf/AJuIHowJJh4ksWlaAwkStomQdN1UKiy0BYUNbMubh222Q2S3TZ6Z2R1+38/tSR6G5/DN0+nM02mR9fWIBWgozvcCAO+QO4SQO4SQO4SUunfprnCoO1J3tq66ubL8UFnpjcTyd/H56/NLC+uP7qUeufHrLMu6lljyYA58yvnca4KB3rbGvvZITTBgWVZqa3twKj4UjbuRuN2Hx5+znpapU3PgU0XOPojsaWkY6GxrrAimh8OxxIUbtxbX3Q3d/ktnk6mLY9NXb8+5NAe+5mTulztaPzvVnBl+/nvs0viMUxfPrSsc+vWdM5Zlvfrjb9k2ZqfmwL8cu5n59o3T7zWHM8Pzo5Nebo3nmuqHY4mVjY3uSF22TJ2aA/9yJvfLHa321vvHZjy+DRi6Ff9zZc2yrKbKcrfnwL8cuJnpaWn45vWXMsPhWOL9XyYMrwm4wfS5e00wMNDZlhmmtrb7x6cNrwm4xDT33rbGzHMYy7IGpx7fDAAFyDT3vvaIfTgUjRteEHCPUe5d4VD6XVLa6N8P3H6XBJgwyr07Umcf/jS7aLYYwF1GuZ+tq7YPxxf/NVtMVl3hUPooS4HMgU8ZPXdv3v1w+o9/kmaLycrL8zCcmdnHjHI/VLbrx924cbefY3nz+ZqnnnVxew58zcUDwI64envubjKVPsfywejknpuul3Pga0a5r25sBkuePJmpCQbc2OC9PA/DmZn9zSj32Mqa/UHkicMV91xIxMvzMJyZ2d+MnszcXFi2Dztqq8wWs7fMa9oc72u9nAP/Msr9h/iCfXiuqd5sMYC7jHK/lliy36yfqT1ceyCQYz6QX6ZnZgandh2S+fjFSLaZQN6Z5j4wGZtNpjLDvvYIf8lDwXLgOzMXx54ccA+WFF/paMsxGcijEuvt84aXiC6tBoqLX6l/fM7kZKji4db29cRy7p/K6AqHXqg4cCe57qM58Cln3qpeGp9pqTyY+eeqVzpb/0quP+Mb+EI7D8OZmX3Mgd097fv4vH2PfzcSDhQXj849yPEjPS0NI291vNZw5PTRqt7WxoX1h9Gl1QKfA19z/bNK/ePTOV7ZePl9GL4zA8d297To0uqX0XhyY/PU0aqDpSUnQxUfnTh2JFg2cX9lbXPr//M/aW+6s5q6ubjcVFn+8937e16z0ObAvxze3e2e5ZOoTZXlmTMq2f4QKLQ58C8XcwcKDd93hxByhxByhxByh5Ciierj+V4D4BF2dwgprf/0Qr7XAHikaGdnJ99rADzCzQyEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuEkDuElCa++CrfawA8wn8SDyHczEBI0bGRl/O9BsAj7O4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4QQu4Q8h+YmZtOlOJspAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneUzb);
export default __webpack_public_path__ + "static/media/phone-uzb.b8973e676c0a0f9e1ef213419e418cc0.svg";
export { ForwardRef as ReactComponent };